import { observer } from "mobx-react-lite";
import React from "react";
import { IUploaderColumnConfig } from "../../../../../../components/ui/UploaderFlow/types/types";
import { GridTypes } from "../../../../../../enums";
import { Uploader } from "../../../../../../components/ui/UploaderFlow/Uploader";
import { RoleAddon } from "../../../../../../components/ui/UploaderFlow/addons/EntityRelationAddons/RoleAddon/RoleAddon";
import I18n from "../../../../../../core/localization/I18n";

interface RoleUploaderModalProps {
  columnConfig: IUploaderColumnConfig[];
  onSubmit: any;
}

export const RoleUploaderModal: React.FC<ReactProps & RoleUploaderModalProps> = observer(
  ({ columnConfig, onSubmit }) => {
    return (
      <Uploader
        gridType={GridTypes.JOB_ROLES_GRID}
        fields={columnConfig}
        isOpen={true}
        onClose={() => {}}
        entityRelationWarning={I18n.t("phrases.jobRolesEntityRelationWarning")}
        onSubmit={onSubmit}
        addons={[RoleAddon]}
      />
    );
  }
);
